import parse, { HTMLReactParserOptions } from "html-react-parser";

export const removeProtocol = (stringToClean: string) => {
  if (!stringToClean) {
    return ``;
  }
  return stringToClean.replace(/^\/\/|^.*?:(\/\/)?/, ``).replace(/^\//, ``);
};

export const removeProtocolOrSlash = (stringToClean: string) => removeProtocol(stringToClean).replace(/^\//, ``);

export const validContent = (
  data: string,
  isDecodingRequired: boolean | undefined,
  allowedTags: { [elementName: string]: string[] }
): string => {
  const decodeFlag =
    isDecodingRequired !== undefined ? isDecodingRequired : true;
  try {
    const content = decodeFlag ? decodeURIComponent(data) : data;
    return isClient() ?
      clientValidContent(content, allowedTags) :
      serverValidContent(content, allowedTags);
  } catch (err) {
    console.error(err);
    return "INVALID_HTML";
  }
};

export const isClient = (): boolean => !!(
  typeof window !== "undefined" &&
  window.document &&
  window.document.createElement
);

export const clientValidContent = (
  content: string,
  allowedTags: { [elementName: string]: string[] }
): string => {
  const temp = document.createElement("div");

  temp.innerHTML = content;
  return isApprovedContent(
    Array.prototype.slice.call(temp.querySelectorAll("*")),
    allowedTags
  ) ?
    content :
    "INVALID";
};

export const isApprovedContent = (
  elements: HTMLElement[],
  allowedTags: { [elementName: string]: string[] }
): boolean => (
  // search for dis-allowed tags
  elements.find(element => {
    let allowed = allowedTags[element.tagName];
    if (allowed) {
      if (
        Array.prototype.slice
          .call(element.attributes)
          .find((attribute: Attr) => allowed.indexOf(attribute.name) < 0)
      ) {
        allowed = undefined; // found dis-allowed attribute
      }
    }

    return !allowed; // return true if dis-allowed element found
  }) === undefined
);

export const serverValidContent = (
  content: string,
  allowedTags: { [elementName: string]: string[] }
): string => {
  const INVALID_LABEL_CONTENT = "INVALID_INVALID_LABEL_CONTENT";
  /* const isValidNode = () => true;
    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
    const processingInstructions = [
      {
        processNode: processNodeDefinitions.processDefaultNode,
        shouldProcessNode: (node: any) => {
          let isValidTag = true;
          if (node && node.next && node.next.name) {
            const allowed = allowedTags[node.next.name.toUpperCase()];
            if (allowed) {
              const keys = Object.keys(node.next.attribs);
              if (Array.prototype.slice.call(keys).find((attribute: any) => {
                return allowed.indexOf(attribute) < 0;
              })) {
                isValidTag = false; // found dis-allowed attribute
              }
            } else {
              isValidTag = false;
            }
          }
          return isValidTag;
        },
      },
      {
        processNode: () => INVALID_LABEL_CONTENT + content,
        shouldProcessNode: (node: any) => {
          return true;
        },
      },
    ];*/
  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (domNode.next && domNode.next.name) {
        console.log("In UF TextTS domNode.nexxt.Name....", domNode.next.name);
        let isValidTag = true;
        const allowed = allowedTags[domNode.next.name.toUpperCase()];
        if (allowed) {
          const keys = Object.keys(domNode.next.attribs);
          if (
            Array.prototype.slice.call(keys).find((attribute: any) => allowed.indexOf(attribute) < 0)
          ) {
            isValidTag = false; // found dis-allowed attribute
          }
        } else {
          isValidTag = false;
        }
        if (isValidTag) {
          console.log("In UF TextTS return domNode....", domNode);
          return domNode;
        }
      } else {
        return INVALID_LABEL_CONTENT + content;
      }
    }
  };
  // const htmlToReactParser = new HtmlToReact.Parser();
  const reactComp = parse(content, options);
  console.log(`reactComp......${  reactComp}`);
  // htmlToReactParser.parseWithInstructions(content, isValidNode, processingInstructions);

  if (
    (typeof reactComp === "string" &&
      reactComp.startsWith(INVALID_LABEL_CONTENT)) ||
    (typeof reactComp === "object" &&
      reactComp[0] &&
      reactComp[0].toString().startsWith(INVALID_LABEL_CONTENT))
  ) {
    return "INVALID";
  }
  return content;
};

export const isEmptyString = (str: string) => str && str === "";

export const titleCase = (value: string): string => {
  if (!value) {
    return ``;
  }
  return value
    .split(" ")
    .map(w => w[0].toUpperCase() + w.substr(1).toLowerCase())
    .join(" ");
};
